import { render, staticRenderFns } from "./CrudExpansionPanel.vue?vue&type=template&id=4f42a6d2&scoped=true&"
import script from "./CrudExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./CrudExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./CrudExpansionPanel.vue?vue&type=style&index=0&id=4f42a6d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f42a6d2",
  null
  
)

export default component.exports